export default "__VITE_ASSET__CANM60cN__"